import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UiSpinner } from 'src/components/UI/Spinner';
import { FULL_SCREEN_LOADER_TRANSPARENT_ID } from 'src/config';

type Props = {
  useText?: boolean;
  transparent?: boolean;
};

export const UiFullScreenLoader: React.FC<Props> = ({ useText = true, transparent = false }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames('fullscreen-loading-container', {
        'transparent-background': transparent,
      })}
      id={transparent ? FULL_SCREEN_LOADER_TRANSPARENT_ID : 'fullScreenProgressCircle'}
    >
      {useText && <h3>{t('common.loader.text')}</h3>}
      <UiSpinner big />
    </div>
  );
};
